import React from 'react';

const Component = props => {
	return (
		<>
			<div className='pt-[5px]'>
				<h2 className='text-[36px] text-[#282e3f] mb-[25px]'>Droit de la jeunesse</h2>
			</div>
			<div className='mt-[30px]'>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Le cabinet GAVA-<i>Lex</i> vous conseillera et vous défendra dans toutes les affaires de droit de la
					jeunesse que vous soyez le parent, le <strong>mineur</strong> ou la famille d'accueil.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Lorsqu'un mineur est en <strong>danger</strong> ou pose problème, un suivi personnalisé peut être
					mis en place au niveau du <strong>SAJ</strong> et ce, en accord avec les parents et le mineur. A
					cette occasion, le cabinet peut assister les parents ou le mineur lors des rendez-vous avec la
					Conseillère et/ou la déléguée.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Si aucun accord ne peut intervenir, la situation peut être judiciarisée, partir en justice. Ainsi,
					la situation de l'enfant sera examinée par le <strong>tribunal de la jeunesse</strong> qui peut
					prendre une mesure d'accompagnement d'ordre éducatif ou ordonner le <strong>placement</strong> de
					l'enfant.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Le cabinet pourra assister les parents ou le mineur devant le tribunal de la jeunesse et le{' '}
					<strong>SPJ</strong> qui devra mettre en œuvre la mesure qui aura été décidée par le tribunal.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Le cabinet peut également assister le mineur qui doit comparaître devant le juge de la jeunesse
					suite à une <strong>infraction</strong>.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Enfin, le cabinet peut également assister le mineur qui doit être entendu par la{' '}
					<strong>police</strong>. En effet, tout mineur qui doit être entendu par la police en qualité de
					suspect doit obligatoirement être assisté d'un conseil.
				</p>
				<div className='organigation-text w-[64%] col:float-none  col:w-full mt-[30px]'>
					<h2 className='text-[24px] text-[#282e3f] mb-[8px] block'>Aperçu des Cas Pratiques : </h2>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Audition des mineurs à la police
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Placement des enfants
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Assistance devant le SAJ, SPJ, etc..
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Défense devant le tribunal de la jeunesse
					</span>
				</div>
			</div>
		</>
	);
};

export default Component;
